import { accordionClasses, accordionSummaryClasses, Components } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { CaretDown } from 'phosphor-react';

import { black, primaryColors } from './styles/colors';
import { body2, lead } from './typography';

declare module '@mui/material/Divider' {
  interface DividerPropsVariantOverrides {
    small: true;
  }
}

const MuiAccordion: Components<Omit<Theme, 'components'>>['MuiAccordion'] = {
  defaultProps: {
    disableGutters: true,
  },
  styleOverrides: {
    root: {
      margin: 0,
      boxShadow: 'none',
      [`.${accordionClasses.expanded}:first-of-type, :first-of-type`]: {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        borderTop: '1px solid transparent',
        overflow: 'hidden',
      },
      [`.${accordionClasses.expanded}:last-of-type, :last-of-type`]: {
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        borderBottom: '1px solid transparent',
      },
      '&:before': {
        display: 'none',
      },
    },
  },
};

export const MuiAccordionSummary: Components<Omit<Theme, 'components'>>['MuiAccordionSummary'] = {
  defaultProps: {
    expandIcon: <CaretDown />,
  },
  styleOverrides: {
    root: {
      padding: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: black['45%'],
      ...lead,
      [`.${accordionSummaryClasses.expandIconWrapper}`]: {
        color: primaryColors[100],
      },
      [`.${accordionSummaryClasses.content}`]: {
        margin: 0,
      },
      [`.${accordionSummaryClasses.content}.${accordionSummaryClasses.expanded}`]: {
        margin: 0,
      },
    },
  },
};

export const MuiAccordionDetails: Components<Omit<Theme, 'components'>>['MuiAccordionDetails'] = {
  styleOverrides: {
    root: {
      ...body2,
      margin: 0,
      padding: '32px',
      background: black['15%'],
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
    },
  },
};

export default MuiAccordion;
